import React, { useState } from "react";

import PropTypes from "prop-types";

import {
    useFloating,
    autoUpdate,
    offset,
    flip,
    shift,
    useHover,
    useInteractions,
    FloatingPortal
} from '@floating-ui/react';

const Tooltip = ({
    trigger,
    direction,
    content,
    className
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const { refs: { setReference, setFloating }, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [offset(10), flip(), shift()],
        whileElementsMounted: autoUpdate,
        placement: direction
    });

    const hover = useHover(context, { move: false });

    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover
    ]);

    return (
        <>
            {trigger({ ref: setReference, ...getReferenceProps() })}
            {isOpen && content && (
                <FloatingPortal>
                    <div
                        ref={setFloating}
                        style={{ ...floatingStyles }}
                        {...getFloatingProps()}
                        className={`tooltip ${className || ''}`}
                    >
                        {content}
                    </div>
                </FloatingPortal>
            )}
        </>
    );
};

Tooltip.defaultProps = {
    direction: 'bottom'
};

Tooltip.propTypes = {
    trigger: PropTypes.func,
    direction: PropTypes.oneOf([
        'top',
        'right',
        'bottom',
        'left',
        'top-right',
        'bottom-right'
    ]),
    // content: PropTypes.oneOf([
    //     PropTypes.string,
    //     PropTypes.arrayOf(PropTypes.node),
    //     PropTypes.node
    // ]),
    className: PropTypes.string
};

export default Tooltip;
